import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './styles/index.scss';
import permission from './directives/permission'

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.directive('permission', permission)

// 优化路由导航方法，捕获并忽略预期内的导航错误
const enhanceRouterMethods = () => {
  const originalPush = router.push;
  const originalReplace = router.replace;
  
  // 导航错误过滤函数
  const filterNavigationError = (err) => {
    // 忽略重复导航和重定向错误
    if (err?.name === 'NavigationDuplicated' || 
        (err?.message && (err.message.includes('Redirected when going from') || err.message.includes('Navigation cancelled')))) {
      return;
    }
    // 对于其他错误，保留错误信息但不抛出
    console.log('路由导航发生错误:', err?.message || err);
  };
  
  router.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) {
      return originalPush.call(this, location, onResolve, onReject);
    }
    return originalPush.call(this, location).catch(filterNavigationError);
  };
  
  router.replace = function replace(location, onResolve, onReject) {
    if (onResolve || onReject) {
      return originalReplace.call(this, location, onResolve, onReject);
    }
    return originalReplace.call(this, location).catch(filterNavigationError);
  };
};

// 增强路由方法
enhanceRouterMethods();
import { initRouterOnRefresh } from './router'

Vue.config.productionTip = false

// 在应用初始化时调用，处理页面刷新
initRouterOnRefresh().then(() => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
